import { Icon } from '@design/components/icon/Icon';
import * as Radix from '@radix-ui/react-dropdown-menu';
import filterStyles from '@terminal/components/filter/Filter.module.scss';
import { useTranslation } from 'react-i18next';

interface FilterResetButtonProps {
  handleReset: (e: Event) => void;
}

export const FilterResetButton = ({ handleReset }: FilterResetButtonProps) => {
  const { t } = useTranslation(['common']);
  return (
    <Radix.Item className={filterStyles.resetItem} onSelect={handleReset}>
      <p
        className={filterStyles.resetButton}
        data-reset-button
        data-testid="reset-label"
      >
        <span className={filterStyles.resetIconWrapper}>
          <Icon
            iconName="Reset"
            size={16}
            fillColor="var(--icon-primary)"
            className={filterStyles.resetIcon}
          />
        </span>
        <span className={filterStyles.resetButtonLabel}>
          {t('common:filters.reset')}
        </span>
      </p>
    </Radix.Item>
  );
};
